import { useContext } from 'react'

import { VatStatusContext } from './VatStatusContext'

export const useVatStatus = () => useContext(VatStatusContext)
